<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
               <span class="pr-"><strong>총 {{items.length}}건</strong></span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-row>
                  <b-col sm="6">
                    <b-button size="sm" variant="danger" v-on:click="deleteMainBanner()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 delete_button_on' : 'mx-1 delete_button_off'">
                      <h5 style="margin-bottom:0px">
                        <i class="fa fa-remove"></i> 삭제
                      </h5>
                    </b-button>
                  </b-col>
                  <b-col sm="6">
                    <b-form-select v-model="perPage" :options="pageOptions"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="12">
                <b-table striped hover :fields="fieldobj.fieldItems" :items="items" :busy="items == 0" :current-page="currentPage" :per-page="perPage">

                  <div slot="table-busy" class="text-center my-2">
                    <div>
                      <strong>데이터가 없습니다.</strong>
                    </div>
                  </div>

                  <template slot="HEAD_selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" v-model="selectAll" @change="selectAllRows">
                    </div>
                  </template>

                  <template slot="selectcheck" slot-scope="data" >
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>

                  <template slot="active_yn" slot-scope="data">
                    <div>
                      <c-switch type="text" :id="'activeSelect'+data.item.rnum" variant="primary" v-model="data.item.active_yn" v-on:change="bannerActiveYN(data.item, data.item.rnum)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </div>
                  </template>

                  <template slot="postsubject" slot-scope="data">
                    <div>
                      <a href="javascript:void(0)" v-on:click="mainBannerInfoGo(data.item)">{{data.item.postsubject}}</a>
                    </div>
                  </template>

                  <template slot="slot_number" slot-scope="data">
                    <div style="width:100px">
                      <select v-if="data.item.active_yn == 'Y'" :id="'slotSelect'+data.item.rnum" size="0" class="form-control" v-on:change="slotOnChange(data.item, $event.target.value, data.item.rnum)">
                        <option v-for="optItem in selectSlotNumbers"
                                :value="optItem.banner_code+'|'+optItem.slot_number+'|'+optItem.postsubject"
                                :selected="optItem.slot_number == data.item.slot_number">
                          {{optItem.slot_number}}
                        </option>
                      </select>
                      <div v-else>비활성</div>
                    </div>
                  </template>

                  <template slot="bannerdate" slot-scope="data">
                    {{data.item.start_date}} ~ {{data.item.end_date}}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="center"/>
              </b-col>
            </b-row>
          </b-col>

        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/site/'+queryParams.banner_type+'management/form?status=insert'">
            <i class="fa fa-hand-o-up"></i> 신규등록
          </b-button>
        </div>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>


import cSwitch from '../../../../components/Switch'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../event-bus";
import swal from "sweetalert2";
const moment = require("moment");

export default {
  name: 'MainList',
  props: {
    queryParams: {
      type: Object
    },
    fieldobj: {
      type: Object
    },
    fullDate: {
      type: Array
    },
    currentTab: {
      type: String
    },
  },

  components: {
    PulseLoader,
    cSwitch
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindMain", () => {
      this.findMainManagementList();
    });
  },
  data () {
    return {
      drDeleteRows: [],
      selectSlotNumbers: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      selectAll: false,
      slotParams: {},
      items: [],
    }
  },
  mounted() {
    this.queryParams.banner_type = this.currentTab;
    this.queryParams.active_yn      = 'all';
    this.queryParams.day_code       = 'dayall';
    this.queryParams.search_type    = 'total';
    this.queryParams.search_keyword = '';
    this.findMainManagementList();
  },
  methods: {
    // 검색 리스트 불러오기
    findMainManagementList () {
      var self = this;
      var token = sessionStorage.getItem("myToken");

      self.queryParams.start_date = this.$parent.getFormatDate(this.fullDate[0]);
      self.queryParams.end_date = this.$parent.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();

      data.append('objs', param);
      self.$http.post('/api/select/mainManagementList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          self.selectSlotNumbers = [];
          self.items.forEach(function (el, idx, arr){
            el.rnum = self.items.length - (idx);
            el.selectchecked = false;
            // 활성화된 배너면 관리를 위한 selectSlotNumbers 배열에 push
            if(el.active_yn == 'Y'){
              console.log('el >>>',el);
              self.selectSlotNumbers.push(el);
            } else {
              console.log('else el >>>',el);
            }
          });
        })
    },


    // 상세 페이지 이동, 배너코드 세션 세팅
    mainBannerInfoGo (row) {
      var self = this;
      var url = '#/site/'+self.queryParams.banner_type+'management/form?status=update';
      self.$session.set('bannercode', row.banner_code);
      location.href = url;
    },

    // 슬롯 순번 변경
    slotOnChange (data, value, selectNum) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var items = data;
      var preSlotNumArr = value.split("|");
      if(data.slot_number != preSlotNumArr[1]){
        swal.fire({
          title: '순서 설정!',
          html: "<strong>이전 순서 - "+preSlotNumArr[2]+"("+preSlotNumArr[1]+")</br>변경 순서 - "+items.postsubject+"(<span style='color:red'>"+items.slot_number+" => "+preSlotNumArr[1]+"</span>)</strong></br>변경 하시겠습니까?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((swalResult) => {
          if (swalResult.value) {
            self.slotParams.banner_code = items.banner_code;
            self.slotParams.banner_type = items.banner_type;
            self.slotParams.slot_number = items.slot_number;
            self.slotParams.old_banner_code = preSlotNumArr[0];
            self.slotParams.old_slot_number = preSlotNumArr[1];
            var param = encodeURI(JSON.stringify(self.slotParams));
            var data = new FormData();
            data.append('objs', param);
            self.$http.post('/api/update/slotNumbers?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '순서가 설정되었습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                  $("#slotSelect"+selectNum).val(items.banner_code+'|'+items.slot_number+'|'+items.postsubject);
                  self.findMainManagementList();
                });
              })
          }else{
            $("#slotSelect"+selectNum).val(items.banner_code+'|'+items.slot_number+'|'+items.postsubject);
          }
        })
      }
    },

    // 배너 활성화/비활성화
    bannerActiveYN (data, selectNum) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var items = data;
      var oldActive = (items.active_yn == 'Y'?'N':'Y');
      var newActive = items.active_yn;
      var bannerChk = true;

      if (items.banner_type == 'banner01' || items.banner_type == 'banner02'){
        bannerChk = false;
      }

      // banner01, banner02가 아니고 활성화 가능한 배너 5개 제한
      if(bannerChk && oldActive == 'N' && self.selectSlotNumbers.length == 5){
        data.active_yn = oldActive;
        $("#activeSelect"+selectNum).find("input:checkbox[class='switch-input']").prop("checked", false);
        swal.fire('배너 사용은 최대 5개까지 입니다.', '', 'error').then(function() {
          self.findMainManagementList();
        });
      }else{
        // 최소 제한 배너
        if(oldActive == 'Y' && self.selectSlotNumbers.length == 1 && self.queryParams.banner_type!='popup' ){
          data.active_yn = oldActive;
          $("#activeSelect"+selectNum).find("input:checkbox[class='switch-input']").prop("checked", true);
          swal.fire('배너는 최소 1개 이상<br/> 게재되어야 합니다!', '', 'warning').then(function() {
            self.findMainManagementList();
          });
          //배너 활성화 진행
        }else{



          self.$http.get('/api/update/bannerActiveYn?access_token='+token + '&bannercode='+items.banner_code + '&newactive='+newActive+'&banner_type='+items.banner_type)
            .then((result) => {
              self.findMainManagementList();
            })
        }
      }
    },
    selectAllRows () {
      var self = this;
      self.drDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        el.selectchecked = self.selectAll;
        if(el.selectchecked){
          self.drDeleteRows.push(el.banner_code);
        }
      });
    },

    // 삭제 리스트 개별 선택
    drListRows () {
      var self = this;
      self.drDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        if(el.selectchecked){
          self.drDeleteRows.push(el.banner_code);
        }
      });
    },

    // 선택 베너 삭제
    deleteMainBanner () {
      var self = this;
      if (self.items.some(item => item.active_yn === 'Y' && self.drDeleteRows.includes(item.banner_code))) {
        swal.fire(
          '활성화된 게시물은 삭제할 수 없습니다.',
          '',
          'error'
        ).then(function() {
          // callback function
        });
        return;
      }
      swal.fire({
        title: '게시물 삭제!',
        html: "<b>선택하신 게시물이 모두 삭제 됩니다.</br> 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.drDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          // console.log(self.drDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);
          self.$http.post('/api/delete/mainBanner?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '게시물이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.drDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findMainManagementList();
              });
            })
        }else{
          // cansel
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/site/main/component/MainList.vue